import React, { Component } from "react";
import {
  Wrapper,
  Title,
  Row,
  Spin,
  Copy,
  Button,
  Bold,
  Icon
} from "app/NativeComponents/common";
import StripeForm from "app/NativeComponents/components/StripeForm";

class CardInfo extends Component {
  render() {
    const {
      colors,
      address,
      editing_card,
      editing_address,
      card_info,
      loading
    } = this.props;
    return (
      <Wrapper
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: "solid",
          borderBottomColor: colors.border_color,
          paddingBottom: 20,
          paddingTop: 20
        }}
      >
        <Row>
          <Wrapper style={{ padding: 10, flex: 1 }}>
            <Title>2.) Credit Card:</Title>
          </Wrapper>
          {editing_card &&
          !editing_address &&
          !loading &&
          this.props.cardCompleted(card_info) ? (
            <Wrapper>
              <Button
                onPress={() => this.props.toggleEditCard(false)}
                style={{ padding: 10 }}
              >
                <Copy
                  style={{ color: colors.active_color, textAlign: "center" }}
                >
                  Cancel Update
                </Copy>
              </Button>
            </Wrapper>
          ) : null}
        </Row>
        {editing_card && !editing_address && !loading ? (
          <StripeForm
            address={address}
            buttonRight={true}
            buttonText={"Save"}
            saveBilling={this.props.saveCard}
            loading={loading}
          />
        ) : editing_card && !editing_address && loading ? (
          <Wrapper style={{ padding: 20 }}>
            <Row>
              <Spin size="small" />
              <Copy style={{ marginLeft: 5 }}>Saving Card...</Copy>
            </Row>
          </Wrapper>
        ) : !editing_card && this.props.cardCompleted(card_info) ? (
          <Wrapper style={{ padding: 20 }}>
            <Row>
              <Wrapper style={{ flex: 1 }}>
                <Row>
                  <Icon
                    icon="credit_card"
                    size={18}
                    style={{ marginRight: 5 }}
                  />
                  <Copy>
                    Card ending in <Bold>{card_info.last4}</Bold>
                  </Copy>
                </Row>
              </Wrapper>
              {!editing_address ? (
                <Wrapper>
                  <Button
                    onPress={() => this.props.toggleEditCard(true)}
                    style={{ padding: 10 }}
                  >
                    <Copy
                      style={{
                        color: colors.active_color,
                        textAlign: "center"
                      }}
                    >
                      Update Card
                    </Copy>
                  </Button>
                </Wrapper>
              ) : null}
            </Row>
          </Wrapper>
        ) : null}
      </Wrapper>
    );
  }
}

export default CardInfo;
